/**
 * VariantPicker - Direct JavaScript conversion from variant-select.directive.ts
 * NO FETCHING! All variant data is already in the page as JSON.
 */

/**
 * VariantPicker - Direct JavaScript conversion from variant-select.directive.ts
 * NO FETCHING! All variant data is already in the page as JSON.
 */

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', class VariantPicker extends HTMLElement {
    constructor() {
      super();

      // Properties
      /** @type {any[]} */
      this.variants = [];
      /** @type {any} */
      this.currentVariant = null;
      /** @type {any[]} */
      this.currentOptions = [];
      /** @type {any[]} */
      this.previousOptions = [];
      /** @type {any} */
      this.variantsData = null;
      /** @type {any} */
      this.productMetafields = null;
      /** @type {boolean} */
      this.isPDP = false;
      /** @type {HTMLElement | null} */
      this.rootEl = null;
      /** @type {boolean} */
      this.isCustomRugs = false;
      /** @type {HTMLElement[]} */
      this.fieldsets = [];
      /** @type {HTMLElement | null} */
      this.productOptionInventory = null;
      /** @type {HTMLElement | null} */
      this.swatchUpsell = null;
      /** @type {HTMLElement | null} */
      this.lowInventoryNotice = null;
      /** @type {number | null} */
      this.lowInventoryThreshold = null;
      /** @type {HTMLElement[]} */
      this.shopCollectionSections = [];
      /** @type {any[]} */
      this.dynamicSelects = [];
      /** @type {any[]} */
      this.cylindoFabricCards = [];
      /** @type {boolean} */
      this._urlVariantAppliedOnInit = false;
    }

    getUrlVariantId() {
      const rawVariant = window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
      const parsed = rawVariant ? parseInt(rawVariant, 10) : null;
      return Number.isFinite(parsed) ? parsed : null;
    }

    applyVariantSelection(/** @type {any} */ variant, source = 'unknown') {
      if (!variant) return false;
      this.currentVariant = variant;
      this.currentOptions = [...variant.options];
      this.fieldsets.forEach((fieldset, i) => {
        const val = variant.options[i];
        if (!val) return;
        const radio = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(val)}"]`);
        if (radio) radio.checked = true;
      });
      console.log('[VariantPicker][Init] Applied variant selection from', source, variant);
      return true;
    }

  connectedCallback() {
      // Initialize
      this.isPDP = document.body.classList.contains('template-product');
      this.isCustomRugs = !!document.querySelector('[custom-rugs]');
      this.rootEl = document.querySelector('main');

      // Get fieldsets
      this.fieldsets = Array.from(this.querySelectorAll('fieldset:not(.product-grouping)'));

      // Get additional elements
      this.productOptionInventory = this.querySelector('[product-option-inventory]');
      this.swatchUpsell = (this.rootEl?.querySelector('.product-metas .custom-rug-upsell--pdp, .product-metas .custom-rug-upsell, .custom-rug-upsell') || null);
      this.lowInventoryNotice = (this.rootEl?.querySelector('[low-inventory-notice]') || null);
      const thresholdAttr = this.getAttribute('low-inventory-threshold');
      this.lowInventoryThreshold = thresholdAttr ? parseInt(thresholdAttr || '0', 10) : null;
      this.shopCollectionSections = Array.from(document.querySelectorAll('[shop-collection]'));

      // Load variant data from JSON script in the page
      this.loadVariantData();

      if (!this.variantsData) {
        return;
      }

      // Parse variants
      this.parseVariants();
      const urlVariantId = this.getUrlVariantId();
      console.log('[VariantPicker][Init] URL Variant:', urlVariantId);

      // URL variant should be source of truth on initial load.
      if (urlVariantId) {
        const urlVariant = this.variants.find(v => v.id === urlVariantId);
        if (urlVariant) {
          this._urlVariantAppliedOnInit = this.applyVariantSelection(urlVariant, 'url');
          console.log('[VariantPicker][Init] Matched Variant from URL:', this.currentVariant);
        }
      }

      if (!this._urlVariantAppliedOnInit) {
        // Set current options based on checked inputs
        this.updateCurrentOptions();
        console.log('[VariantPicker][Init] Initial checked options:', this.currentOptions);

        // Find current variant
        // On initial load, we want to update gallery even if variant didn't "change"
        // So we pass false to prevent gallery update here, and let updatePDP handle it
        this.updateCurrentVariant(false);
        console.log('[VariantPicker][Init] Matched Variant from checked options:', this.currentVariant);
      }

      // Fix: PLP→PDP fallback — radio inputs may not be checked yet when connectedCallback runs
      // (variant-inventory-guard.js sets them later). Recover the correct variant from the
      // hidden select[name="id"] which is already set correctly before we initialize.
      if (!this.currentVariant && this.isPDP) {
        const variantIdInput = document.querySelector('input[name="id"], select[name="id"]');
        const fallbackId = window.__INITIAL_VARIANT_FROM_URL
          ? parseInt(window.__INITIAL_VARIANT_FROM_URL, 10)
          : (variantIdInput?.value ? parseInt(variantIdInput.value, 10) : null);

        if (fallbackId && !isNaN(fallbackId)) {
          const fallbackVariant = this.variants.find(v => v.id === fallbackId);
          if (fallbackVariant) {
            console.log('[VariantPicker][Init] Applying fallback variant from hidden/url:', fallbackVariant);
            this.applyVariantSelection(fallbackVariant, 'hidden-input-fallback');
          }
        }
      }

      console.log('[VariantPicker][Init] Final currentVariant after fallback resolution:', this.currentVariant);
      document.dispatchEvent(new CustomEvent('variant:initial-stabilized', {
        detail: {
          variantId: this.currentVariant?.id || null,
          options: this.currentOptions || []
        }
      }));
      console.log('[VariantPicker][Init] variant:initial-stabilized dispatched with variantId:', this.currentVariant?.id || null);

      // For furniture_new template: Select variant on page load to update gallery
      const productGalleryEl = /** @type {HTMLElement | null} */ (document.querySelector('[product-gallery]'));
      const isFurnitureNew = (productGalleryEl?.dataset?.templateSuffix === 'furniture_new') ||
                             (this.isPDP && window.location.pathname.includes('furniture'));
      
      if (isFurnitureNew) {
        setTimeout(() => {
          const variantFromUrl = window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
          
          if (variantFromUrl) {
            const variantId = parseInt(variantFromUrl, 10);
            const urlVariantExists = !isNaN(variantId) && this.variants.some(v => v.id === variantId);
            if (urlVariantExists) {
              this.autoSelectVariantFromURL();
              return;
            }
          }
          this.clickFirstAvailableVariant();
        }, 200);
      }

      // Update PDP if on product page
      // This will call updateGallery() which ensures the correct variant's media is shown
      if (this.isPDP) {
        this.updatePDP(true); // Pass true to ensure gallery is updated on initial load
      }

      // Initialize dynamic selects (connect select-product-option handlers)
      this.initializeDynamicSelects();

      // Bind events
      this.bindEvents();

      // Bind upsell select change event (after swatchUpsell is initialized)
      this.bindUpsellEvents();
    }

    loadVariantData() {
      // Find the JSON script in the page (from pdp-variants-json.liquid)
      const scriptEl = this.querySelector('#product-options-variant-data');

      if (!scriptEl) {
        return;
      }

      try {
        this.variantsData = JSON.parse(scriptEl.textContent);
      } catch (e) {
        console.error('Failed to parse variant data:', e);
      }
    }

    parseVariants() {
      const { variants, variants_metafields, product_metafields } = this.variantsData;

      // Attach metafields to each variant
      variants.forEach((/** @type {any} */ variant, /** @type {number} */ index) => {
        variant.metafields = variants_metafields[index];
      });

      this.variants = variants;
      this.productMetafields = product_metafields;
    }

    /**
     * Initialize dynamic selects by connecting select-product-option handlers
     * This allows the size dropdown to recalculate when color changes
     */
    initializeDynamicSelects() {
      // Wait for SelectProductOptionHandler to be available
      if (typeof window.SelectProductOptionHandler === 'undefined') {
        // Retry after a short delay (max 10 retries = 1 second)
        if (!this._initRetryCount) {
          this._initRetryCount = 0;
        }
        
        if (this._initRetryCount < 10) {
          this._initRetryCount++;
          setTimeout(() => this.initializeDynamicSelects(), 100);
        }
        return;
      }
      
      // Find all select-product-option elements within this variant picker
      const selectOptions = this.querySelectorAll('[select-product-option]');
      
      selectOptions.forEach(element => {
        // Initialize handler if not already done
        if (!element.selectProductOptionHandler) {
          element.selectProductOptionHandler = new window.SelectProductOptionHandler(element);
        }
        
        // Add to dynamicSelects array if handler exists and not already added
        if (element.selectProductOptionHandler && !this.dynamicSelects.includes(element.selectProductOptionHandler)) {
          this.dynamicSelects.push(element.selectProductOptionHandler);
        }
      });

      // After initializing dynamic selects, recalculate them to set correct classes on initial load
      // This ensures out-of-stock vs unavailable classes are set correctly from the start
      if (this.dynamicSelects.length > 0 && this.isPDP) {
        this.updateDynamicSelects();
      }
    }

    bindEvents() {
      // Stop event from bubbling to prevent other listeners from interfering
      this.addEventListener('change', (event) => {
        event.stopPropagation(); // Prevent other listeners (like product-gallery.js)
        this.onVariantChange(event);
      });
    }

    /**
     * Bind events specifically for upsell component
     * Called after swatchUpsell element is initialized
     */
    bindUpsellEvents() {
      if (!this.swatchUpsell) return;

      const upsellSelect = /** @type {HTMLSelectElement | null} */ (this.swatchUpsell.querySelector('.upsellTile__optionsInput'));
      if (upsellSelect && !upsellSelect.hasAttribute('data-upsell-listener-bound')) {
        upsellSelect.setAttribute('data-upsell-listener-bound', 'true');
        upsellSelect.addEventListener('change', (event) => {
          this.onUpsellSelectChange(event);
        });
      }
    }

    onVariantChange(/** @type {Event} */ event) {
      const target = /** @type {HTMLInputElement} */ (event.target);
      
      this.updateCurrentOptions();
      
      // Don't update gallery in updateCurrentVariant - let updatePDP handle it after checking media change
      this.updateCurrentVariant(false);

      // Reset gallery dedup guard on every explicit user interaction so that
      // re-clicking the already-selected tile always allows a fresh gallery scroll.
      const productGalleryEl = document.querySelector('[product-gallery]');
      if (productGalleryEl?.productGalleryInstance) {
        productGalleryEl.productGalleryInstance._lastProcessedVariantId = null;
      }

      // Always update dynamic selects (size dropdown) when any option changes
      this.updateDynamicSelects();

      this.updateMVNWarehouseVariants();

      if (this.isPDP) {
        this.updatePDP();
      }
    }

    updateCurrentOptions() {
      // Get selected value from each fieldset
      const beforeOptions = [...this.currentOptions];
      this.previousOptions = [...this.currentOptions];

      if (this.isCustomRugs) {
        // For custom rugs: Check for Color fieldset specifically (CustomRug-color)
        // Color fieldset value IS the variant ID
        const colorFieldset = this.querySelector('fieldset#CustomRug-color') ||
          this.querySelector('fieldset[id*="CustomRug-color"]') ||
          Array.from(this.querySelectorAll('fieldset')).find(fs =>
            fs.querySelector('[cylindo-variant-selector="Color"]')
          );

        if (colorFieldset) {
          const colorInput = /** @type {HTMLInputElement | null} */ (colorFieldset.querySelector('input[type="radio"]:checked'));
          if (colorInput && colorInput.value) {
            this.currentOptions = [colorInput.value]; // Variant ID is the first (and only) option for custom rugs
            return;
          }
        }
      }

      // Regular products: Get selected value from each fieldset
      this.currentOptions = this.fieldsets.map(fieldset => {
        const checked = /** @type {HTMLInputElement | null} */ (fieldset.querySelector('input:checked'));
        return checked ? checked.value : null;
      }).filter(val => val !== null);
      console.log('[VariantPicker][Options] Before override:', beforeOptions, 'After override:', this.currentOptions);
    }

    updateCurrentVariant(updateGallery = true) {
      const prevVariant = this.currentVariant;
      console.log('[VariantPicker][VariantMap] Before override:', prevVariant, 'Current options:', this.currentOptions);
      // Store previous variant for media comparison in updatePDP
      this.previousVariant = prevVariant;

      if (this.isCustomRugs) {
        // For custom rugs, variant ID is in first option
        const variantId = +this.currentOptions[0];
        this.currentVariant = this.variants.find(v => v.id === variantId);
      } else {
        // Find variant where all options match
        this.currentVariant = this.variants.find(variant => {
          return variant.options.every((/** @type {any} */ option, /** @type {number} */ index) => {
            return this.currentOptions[index] === option;
          });
        });

        // If no exact match: keep user's selection, do NOT auto-switch to another color/size
        // (e.g. Gold + 4x6 doesn't exist → show Unavailable, don't switch to Blue 4x6)
        if (!this.currentVariant) {
          this.currentVariant = null;
          // Do NOT call updateFieldsets() - preserve user's selected color/size in UI
        }

        if (this.shopCollectionSections.length > 0) {
          this.updateShopTheCollection();
        }

        if (this.swatchUpsell) {
          this.updateSwatchUpsell();
        }

        if (updateGallery && this.currentVariant?.id !== prevVariant?.id) {
          // Gallery update will be handled in updatePDP
        }

        this.updateSwatches();
      }

      // Gallery update is now handled in updatePDP() to check media change
      // This prevents duplicate calls and ensures proper media change detection
      // We only update gallery if media actually changed (prevents updates when only size changes)
      console.log('[VariantPicker][VariantMap] After override:', this.currentVariant);
    }

    updateFieldsets() {
      if (!this.fieldsets || this.fieldsets.length === 0) return;

      this.fieldsets.forEach((fieldset, index) => {
        if (index < this.currentOptions.length) {
          const optionValue = this.currentOptions[index];
          const radioInput = /** @type {HTMLInputElement | null} */ (fieldset.querySelector(`input[type="radio"][value="${CSS.escape(optionValue)}"]`));

          if (radioInput) {
            radioInput.checked = true;

            // Update selected label
            const selectedLabel = fieldset.querySelector('[variant-selected-option]');
            if (selectedLabel) {
              selectedLabel.textContent = optionValue;
            }
          }
        }
      });
    }

    /**
     * Auto-select variant from URL for furniture_new template
     * This ensures the variant in URL is selected and clicked on page load
     */
    autoSelectVariantFromURL() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const variantIdFromURL = urlParams.get('variant');
        
        if (!variantIdFromURL) {
          return;
        }

        const targetVariantId = parseInt(variantIdFromURL, 10);
        if (isNaN(targetVariantId)) {
          return;
        }

        // Find the variant in variants array
        const targetVariant = this.variants.find(v => v.id === targetVariantId);
        if (!targetVariant) {
          return;
        }

        // Set current options based on variant options
        this.currentOptions = [...targetVariant.options];
        
        // Update fieldsets to select the correct options
        this.fieldsets.forEach((fieldset, index) => {
          if (index < this.currentOptions.length) {
            const optionValue = this.currentOptions[index];
            const radioInput = /** @type {HTMLInputElement | null} */ (fieldset.querySelector(`input[type="radio"][value="${CSS.escape(optionValue)}"]`));

            if (radioInput && !radioInput.checked) {
              // Check the radio input
              radioInput.checked = true;
              
              // Trigger change event to update UI
              radioInput.dispatchEvent(new Event('change', { bubbles: true }));

              // Update selected label if exists
              const selectedLabel = fieldset.querySelector('[variant-selected-option]');
              if (selectedLabel) {
                selectedLabel.textContent = optionValue;
              }

              // Update fabric tile selection state
              const label = radioInput.closest('label');
              if (label) {
                // Remove is-selected from all fabric tiles in this fieldset
                fieldset.querySelectorAll('label.is-selected').forEach(l => l.classList.remove('is-selected'));
                // Add is-selected to current label
                label.classList.add('is-selected');
              }
            }
          }
        });

        // Update current variant
        this.currentVariant = targetVariant;
        this.previousVariant = null; // Reset previous variant for first load

      } catch (error) {
        console.error('[VariantPicker] Error in autoSelectVariantFromURL:', error);
      }
    }

    /**
     * Click first available variant for furniture_new template
     * Priority: 1. In stock variants, 2. Made to order variants, 3. Any available variant
     * This ensures gallery updates on page load
     */
    clickFirstAvailableVariant() {
      try {
        if (!this.variants || this.variants.length === 0) {
          return; // No variants available
        }

        // Sort variants by priority:
        // 1. In stock (available = true and inventory_quantity > 0)
        // 2. Made to order (available = true but inventory = 0 or null)
        // 3. Other available variants
        const sortedVariants = [...this.variants].sort((a, b) => {
          // Both must be available
          if (!a.available && !b.available) return 0;
          if (!a.available) return 1;
          if (!b.available) return -1;

          // Check inventory
          const aInventory = a.inventory_quantity;
          const bInventory = b.inventory_quantity;
          const aInStock = (aInventory !== null && aInventory > 0) || a.inventory_policy === 'continue';
          const bInStock = (bInventory !== null && bInventory > 0) || b.inventory_policy === 'continue';

          // In stock variants first
          if (aInStock && !bInStock) return -1;
          if (!aInStock && bInStock) return 1;

          // If both in stock or both made to order, maintain original order
          return 0;
        });

        // Find first available variant (should be first in sorted array)
        const targetVariant = sortedVariants.find(v => v.available);
        
        if (!targetVariant) {
          return; // No available variant found
        }

        // Now find the radio inputs that match this variant's options
        // For furniture_new, we need to match all options of the variant
        const targetOptions = targetVariant.options;
        
        // Get all fieldsets
        const fieldsets = Array.from(this.fieldsets);
        
        // For each option in the variant, find and check the corresponding radio input
        let allOptionsMatched = true;
        const inputsToCheck = [];
        
        for (let i = 0; i < targetOptions.length && i < fieldsets.length; i++) {
          const optionValue = targetOptions[i];
          const fieldset = fieldsets[i];
          
          // Find radio input with matching value in this fieldset
          const radioInput = /** @type {HTMLInputElement | null} */ (
            fieldset.querySelector(`input[type="radio"][value="${CSS.escape(optionValue)}"]`)
          );
          
          if (radioInput) {
            inputsToCheck.push(radioInput);
          } else {
            allOptionsMatched = false;
            break;
          }
        }
        
        // If we found all matching inputs, check the first one (which will trigger the variant selection)
        if (allOptionsMatched && inputsToCheck.length > 0) {
          // Check if any of these inputs are already checked
          const uncheckedInput = inputsToCheck.find(input => !input.checked);
          
          if (uncheckedInput) {
            // Click the first unchecked input to trigger variant selection
            uncheckedInput.click();
          } else {
            // All inputs are already checked, variant is already selected
            // But we still want to trigger gallery update, so click the first input again
            inputsToCheck[0].click();
          }
        } else {
          // Fallback: If we can't match all options, just click first available unchecked radio
          const firstAvailableInput = /** @type {HTMLInputElement | null} */ (
            this.querySelector('input[type="radio"]:not(:checked)')
          );
          
          if (firstAvailableInput) {
            firstAvailableInput.click();
          }
        }
      } catch (error) {
        console.error('[VariantPicker] Error clicking first available variant:', error);
      }
    }

    updatePDP(updateGallery = true) {
      console.log('[VariantPicker][PDP] updatePDP called with variant:', this.currentVariant, 'updateGallery:', updateGallery);
      // Only update gallery if featured_media changed (prevents gallery update when only size/other options change)
      if (this.currentVariant && updateGallery) {
        // Check if we need to track previous variant for media comparison
        const prevMediaId = this.previousVariant?.featured_media?.id;
        const currentMediaId = this.currentVariant?.featured_media?.id;
        
        const prevVariantId = this.previousVariant?.id;
        const currentVariantId = this.currentVariant.id;
        const variantChanged = prevVariantId !== currentVariantId;
        const hasCustomMediaGallery = !!(this.currentVariant.metafields?.custom?.media_gallery);
        const prevHasCustomMediaGallery = !!(this.previousVariant?.metafields?.custom?.media_gallery);
        
        // Check if this is furniture_new template
        const productGalleryEl = /** @type {HTMLElement | null} */ (document.querySelector('[product-gallery]'));
        const isFurnitureNew = (productGalleryEl?.dataset?.templateSuffix === 'furniture_new') ||
                               (document.body.classList.contains('template-product') && 
                                window.location.pathname.includes('furniture'));
        
        // Check if this is initial load (no previous variant)
        const isInitialLoad = !prevVariantId;
        
        // Update gallery if:
        // 1. Initial load (first time) - always update to show correct variant media on page load
        // 2. Featured media changed (prevMediaId !== currentMediaId), OR
        // 3. For furniture_new: Variant changed AND it has custom media_gallery (even if same featured_media)
        //    This is because custom.media_gallery can be different even if featured_media is same
        // 4. Variant changed AND it has custom media_gallery metafield (even if no featured_media)
        const shouldUpdateGallery = 
          isInitialLoad || // Always update on initial load to show correct variant media
          (currentMediaId && prevMediaId !== currentMediaId) || // Media changed
          (isFurnitureNew && variantChanged && hasCustomMediaGallery) || // Furniture_new: variant changed with custom gallery
          (variantChanged && (!currentMediaId && hasCustomMediaGallery)) || // Variant changed with custom gallery but no featured_media
          (!variantChanged && !!currentMediaId && !isInitialLoad); // Same variant re-clicked → re-scroll to featured_media slide

        if (shouldUpdateGallery) {
          // On initial load, wait a bit for gallery to be fully initialized
          if (isInitialLoad) {
            // Wait for gallery instance to be ready
            setTimeout(() => {
              this.updateGallery();
            }, 300);
          } else {
            this.updateGallery();
          }
        }
      }

      this.updateDynamicSelects();
      this.updateURL();
      this.updatePrice();
      this.updateLeadTime();
      this.updateATC();
      this.updateTabs();
      this.updateTearSheetUrl();
      this.updateCylindo();
      this.updateProductOptionInventory();
      this.updateSwatchUpsell();
      this.updateLowInventoryNotice();

      this.fieldsets.forEach((fieldset) => {
        const selectedLabel = /** @type {HTMLElement | null} */ (fieldset.querySelector('[variant-selected-option]'));
        if (selectedLabel) {
          this.updateSelectedLabel(fieldset, selectedLabel);
        }
      });
    }

    updateURL() {
      // Use requestAnimationFrame to ensure this runs AFTER any other synchronous handlers
      requestAnimationFrame(() => {
        if (!this.currentVariant) {
          // Don't modify URL when variant not yet resolved (e.g. initial load with ?variant=)
          // Stripping variant here would break deep links from search/SKU
          return;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.currentVariant.id.toString());
        const newUrl = url.toString();
        if (newUrl === window.location.href) return;

        window.history.replaceState({ path: newUrl }, '', newUrl);

        // Double-check after a short delay to ensure it wasn't overwritten
        setTimeout(() => {
          if (!this.currentVariant) return;
          const currentUrl = new URL(window.location.href);
          if (currentUrl.searchParams.get('variant') !== this.currentVariant.id.toString()) {
            currentUrl.searchParams.set('variant', this.currentVariant.id.toString());
            window.history.replaceState({ path: currentUrl.toString() }, '', currentUrl.toString());
          }
        }, 100);
      });
    }

    updatePrice() {
      if (this.isCustomRugs || !this.rootEl) {
        return;
      }

      const priceEl = this.rootEl.querySelector('.product-metas__price');
      if (!priceEl) return;

      const currentPriceEl = priceEl.querySelector('.price-value__current');
      const compareAtEl = priceEl.querySelector('.price-value__compare');
      const priceValueEl = priceEl.querySelector('.price-value');
      const percentOffEl = priceEl.querySelector('.product-metas__price-badge--percent-off');

      if (!currentPriceEl) return;

      const priceMultiplier = this.variantsData.price_multiplier || 1;
      const isB2B = !!this.variantsData.is_b2b_customer;
      const currentPrice = this.currentVariant?.price * priceMultiplier;
      let compareAtPrice;

      if (isB2B) {
        const b2bRaw = this.currentVariant?.metafields?.custom?.b2b_compare_at_price ?? this.currentVariant?.metafields?.b2b_compare_at_price;
        const b2bCents = (b2bRaw != null && b2bRaw !== '') ? this.parsePriceToCents(b2bRaw) : null;
        compareAtPrice = (b2bCents != null && b2bCents > 0) ? b2bCents : currentPrice;
      } else {
        compareAtPrice = priceMultiplier !== 1
          ? Math.max(this.currentVariant?.compare_at_price || 0, this.currentVariant?.price)
          : this.currentVariant?.compare_at_price;
      }
      const hasSale = currentPrice < compareAtPrice;
      const percentOffValue = compareAtPrice > 0 ? Math.floor((compareAtPrice - currentPrice) * 100 / compareAtPrice) : 0;

      currentPriceEl.innerHTML = currentPrice ? this.formatMoney(currentPrice) : '';

      if (compareAtEl) {
        compareAtEl.innerHTML = hasSale ? this.formatMoney(compareAtPrice) : '';
      }

      if (priceValueEl) {
        priceValueEl.classList.toggle('price-value--has-sale', hasSale);
      }

      if (percentOffEl) {
        percentOffEl.innerHTML = hasSale ? `${percentOffValue}% Off` : '';
      }

      this.updateTradePrice();
    }

    /** Parse B2B metafield price to cents. Handles dollars (< 10000 or decimal) and Shopify cents (>= 10000). */
    parsePriceToCents(value) {
      if (value == null || value === '') return null;
      if (typeof value === 'object' && value !== null) {
        const amount = parseFloat(value.amount ?? value.value ?? 0);
        return isNaN(amount) ? null : Math.round(amount * 100);
      }
      const str = String(value).replace(/[^0-9.-]/g, '');
      const num = parseFloat(str);
      if (isNaN(num)) return null;
      if (str.includes('.') || num < 10000) return Math.round(num * 100);
      return Math.round(num);
    }

    updateTradePrice() {
      if (!this.rootEl) return;
      const tradePriceEl = this.rootEl.querySelector('.product-metas__trade-price');
      if (!tradePriceEl) return;
      const b2b = this.currentVariant?.metafields?.custom?.b2b_price;
      const hasB2bPrice = !!(b2b && (typeof b2b === 'object' && b2b !== null ? b2b.value : b2b));
      tradePriceEl.style.display = hasB2bPrice ? 'block' : 'none';
    }

    updateATC() {
      if (this.isCustomRugs || !this.rootEl) {
        return;
      }

      const atcSelect = /** @type {HTMLSelectElement | null} */ (this.rootEl.querySelector('select[name="id"]'));
      const addToCartBtn = /** @type {HTMLButtonElement | null} */ (this.rootEl.querySelector('.product-metas [add-to-cart][add-to-cart-flow]'));

      if (!addToCartBtn) return;

      const availableText = addToCartBtn.dataset.langAvailable || 'Add to Cart';
      const soldOutText = addToCartBtn.dataset.langSoldOut || 'Sold Out';

      if (this.currentVariant) {
        if (atcSelect) {
          atcSelect.value = this.currentVariant.id.toString();
        }

        addToCartBtn.setAttribute('add-to-cart', this.currentVariant.id.toString());
        addToCartBtn.disabled = !this.currentVariant.available;
        addToCartBtn.innerHTML = this.currentVariant.available ? availableText : soldOutText;
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML = 'Unavailable';
      }
    }

    updateSelectedLabels() {
      this.fieldsets.forEach(fieldset => {
        const selectedLabel = fieldset.querySelector('[variant-selected-option]');

        if (selectedLabel) {
          const checkedInput = /** @type {HTMLInputElement | null} */ (fieldset.querySelector('input:checked'));
          if (checkedInput) {
            selectedLabel.textContent = checkedInput.value;
          }
        }
      });
    }

    updateSelectedLabel(/** @type {HTMLElement} */ fieldset, /** @type {HTMLElement} */ selectedLabel) {
      const selectedValue = this.getOptionValue(fieldset);
      selectedLabel.innerHTML = selectedValue ? selectedValue.toString() : '';
    }

    getOptionValue(/** @type {HTMLElement} */ fieldset) {
      const checked = /** @type {HTMLInputElement | null} */ (fieldset.querySelector('input:checked'));
      return checked ? checked.value : null;
    }

    updateGallery() {
      if (!this.currentVariant) {
        return;
      }
      
      // Check if variant has featured_media OR custom media_gallery metafield
      const hasFeaturedMedia = !!this.currentVariant.featured_media;
      const hasCustomMediaGallery = !!(this.currentVariant.metafields?.custom?.media_gallery);
      
      if (!hasFeaturedMedia && !hasCustomMediaGallery) {
        return;
      }
      
      // Try to directly update gallery if instance is available (matches TypeScript behavior)
      const productGalleryEl = document.querySelector('[product-gallery]');
      const galleryInstance = productGalleryEl?.productGalleryInstance;
      
      if (galleryInstance && galleryInstance.updateShownVariantMedia) {
        galleryInstance.updateShownVariantMedia(this.currentVariant.id);
      } else {
        // Fallback: Dispatch event if gallery instance not ready yet
        const event = new CustomEvent('variant:changed', {
          detail: {
            variant: this.currentVariant,
            variantId: this.currentVariant.id,
            mediaId: this.currentVariant.featured_media?.id || null
          },
          bubbles: true
        });
        document.dispatchEvent(event);
      }
    }

    /**
     * @param {number} cents
     * @returns {string}
     */
    formatMoney(cents, format = '${{amount}}') {
      if (typeof cents == 'string') {
        cents = ~~(cents).replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || (/** @type {any} */ (window).theme)?.moneyFormat || '${{amount}}';

      function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        const sNumber = (number / 100.0).toFixed(precision);
        const parts = sNumber.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
      }

      const match = formatString.match(placeholderRegex);
      if (match) {
        switch (match[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }
      }

      return formatString.replace(placeholderRegex, value);
    }

    // Additional methods from TypeScript master
    updateLeadTime() {
      if (!this.rootEl) return;
      const leadTimeEl = this.rootEl.querySelector('.product-metas__lead-time, .product-pill__lead-time');
      if (!leadTimeEl) return;

      const variantLeadtime = this.currentVariant?.metafields?.new_my_fields?.lead_time;
      const productLeadTime = this.productMetafields?.new_my_fields?.lead_time;
      const leadTime = variantLeadtime || productLeadTime || '';

      leadTimeEl.innerHTML = leadTime;
    }

    updateDynamicSelects() {
      // Skip if we don't have dynamic selects functionality
      if (!this.dynamicSelects || this.dynamicSelects.length === 0) return;

      // For products with only 1 option, no need to recalculate
      if (this.fieldsets.length === 1) {
        return;
      }

      // Recalculate each dynamic select with appropriate potential variants
      this.dynamicSelects.forEach((select) => {
        if (!select.recalculate || !select.option) return;
        
        // Get the position of this select option (1-based in option object, 0-based in array)
        const selectPosition = select.option.position - 1;
        
        // Filter variants based ONLY on options BEFORE this select's position
        // This way, when recalculating Size, we only filter by Color, not by Size itself
        let potentialVariants = this.variants.filter((variant) => {
          // Check all options before this select's position
          for (let i = 0; i < selectPosition; i++) {
            const selectedOption = this.currentOptions[i];
            if (selectedOption && variant.options[i] !== selectedOption) {
              return false; // This variant doesn't match the selected option at position i
            }
          }
          return true; // All previous options match
        });

        // If no potential variants found, use all variants as fallback
        if (potentialVariants.length === 0) {
          potentialVariants = this.variants;
        }

        // Recalculate this select with the filtered potential variants
        select.recalculate(potentialVariants);
      });
  }

    updateTabs() {
      // Update product tabs with variant details (TypeScript master updateTabs method)
      if (!this.rootEl || !this.currentVariant) return;
      
      const productTabs = this.rootEl.querySelector('.product-tabs');
      if (!productTabs) return;

      const additionalDetailsContainer = productTabs.querySelector('.product-tabs__content-column--details');
      if (!additionalDetailsContainer) return;

      // Generate HTML for additional details based on current variant
      const detailsHTML = this.generateAdditionalDetailsHTML(this.currentVariant);
      additionalDetailsContainer.innerHTML = detailsHTML;
    }

    generateAdditionalDetailsHTML(variant) {
      // Match TypeScript master additionalDetailsTemplate (line 536-602)
      let html = '<ul class="additional-details">';

      // Dimensions (split on "|" into separate lines)
      if (variant?.metafields?.variant?.new_dimensions) {
        const rawDimensions = String(variant.metafields.variant.new_dimensions);
        const formattedDimensions = rawDimensions
          .split('|')
          .map(part => part.trim())
          .join('<br>');

        html += `
          <li class="additional-details__item">
            <span class="additional-details__title">Dimensions</span>
            <span class="additional-details__value">${formattedDimensions}</span>
          </li>
        `;
      }

      // Color
      if (variant?.metafields?.my_fields?.color) {
        html += `
          <li class="additional-details__item">
            <span class="additional-details__title">Color</span>
            <span class="additional-details__value">${variant.metafields.my_fields.color}</span>
          </li>
        `;
      }

      // Material
      if (variant?.metafields?.my_fields?.material) {
        html += `
          <li class="additional-details__item">
            <span class="additional-details__title">Material</span>
            <span class="additional-details__value">${variant.metafields.my_fields.material}</span>
          </li>
        `;
      }

      // Weight (skip for custom rugs)
      if (variant?.metafields?.weight_with_unit && !this.isCustomRugs) {
        html += `
          <li class="additional-details__item">
            <span class="additional-details__title">Weight</span>
            <span class="additional-details__value">${variant.metafields.weight_with_unit}</span>
          </li>
        `;
      }

      // Country of origin (from product metafields)
      if (this.productMetafields?.new_my_fields?.country_of_origin) {
        html += `
          <li class="additional-details__item">
            <span class="additional-details__title">Country of origin</span>
            <span class="additional-details__value">${this.productMetafields.new_my_fields.country_of_origin}</span>
          </li>
        `;
      }

      // Care instructions
      if (variant?.metafields?.my_fields?.care) {
        html += `
          <li class="additional-details__item">
            <span class="additional-details__title">Care instructions</span>
            <span class="additional-details__value">${variant.metafields.my_fields.care}</span>
          </li>
        `;
      }

      // Specifications (with line breaks converted to <br/>)
      if (variant?.metafields?.custom?.specifications) {
        const specifications = variant.metafields.custom.specifications.replace(/(?:\r\n|\r|\n)/g, '<br/>');
        html += `
          <li class="additional-details__item">
            <span class="additional-details__title">Specifications</span>
            <span class="additional-details__value">${specifications}</span>
          </li>
        `;
      }

      // SKU
      if (variant?.sku) {
        html += `
          <li class="additional-details__item">
            <span class="additional-details__title">SKU</span>
            <span class="additional-details__value">${variant.sku}</span>
          </li>
        `;
      }

      html += '</ul>';
      return html;
    }

    updateTearSheetUrl() {
      // Update print tear sheet URL with current variant (TypeScript master updateTearSheetUrl method)
      if (!this.rootEl || !this.currentVariant) return;
      
      const productTabs = this.rootEl.querySelector('.product-tabs');
      if (!productTabs) return;

      // Create URL from current page location
      const tearSheetUrl = new URL(document.location.href);
      
      // Ensure variant parameter is set
      tearSheetUrl.searchParams.set('variant', this.currentVariant.id.toString());
      
      // Set view=print parameter
      tearSheetUrl.searchParams.set('view', 'print');
      
      // Update the print trigger link
      const printTrigger = /** @type {HTMLAnchorElement | null} */ (productTabs.querySelector('.product-tabs__trigger--print'));
      if (printTrigger) {
        printTrigger.href = tearSheetUrl.href;
      }
    }

    updateCylindo() {
      this.updateHoverCards();
    }

    updateHoverCards() {
      // Update Cylindo fabric cards if present
      if (!this.cylindoFabricCards || this.cylindoFabricCards.length === 0) return;

      const hasRendered = this.cylindoFabricCards.every((card) => card.hasRendered);
      if (!hasRendered) {
        this.cylindoFabricCards.forEach((directive) => {
          if (directive.render) directive.render();
        });
      }

      // Update prices on hover cards
      const fabricIdx = this.variantsData?.options?.indexOf('Fabric');
      if (fabricIdx === -1) return;

      this.cylindoFabricCards.forEach((directive) => {
        if (directive.cardCount > 0) {
          const hoverCards = directive.host?.querySelectorAll('.cylindoVariant__hover');
          if (hoverCards) {
            hoverCards.forEach((/** @type {HTMLElement} */ card) => {
              const priceEl = card.querySelector('[cylindo-fabric-price]');
              const fabric = (/** @type {HTMLElement} */ card).dataset.value;
              const options = [...this.currentOptions];
              options[fabricIdx] = fabric;

              const variant = this.variantsData?.variants?.find((/** @type {any} */ variant) => {
                return variant.options.every((/** @type {any} */ opt, /** @type {number} */ i) => options[i] === opt);
              });

              if (variant && priceEl) {
                priceEl.textContent = this.formatMoney(variant.price);
              }
            });
          }
        }
      });
    }

    updateMVNWarehouseVariants() {
      // This is for specific warehouse inventory display
      // Implementation would require additional HTML structure
      // Skipping for now unless needed
    }

    updateProductOptionInventory() {
      if (!this.productOptionInventory) return;

      const previousOptionsMatch = this.previousOptions.length === this.currentOptions.length &&
        this.previousOptions.every((opt, i) => opt === this.currentOptions[i]);

      const changedOptions = this.previousOptions.filter((opt, i) => opt !== this.currentOptions[i]);
      const changedOptionNames = changedOptions.map((opt) => {
        const idx = this.previousOptions.indexOf(opt);
        return this.variantsData?.options?.[idx]?.toLowerCase();
      }).filter(opt => !!opt);

      const idx = this.getInventoryOptionIndex();
      const optName = this.variantsData?.options?.[idx]?.toLowerCase();

      if (idx !== -1 && !previousOptionsMatch && !(optName && changedOptionNames.includes(optName))) {
        this.renderProductOptionValues(idx);
      }
    }

    getInventoryOptionIndex() {
      const opts = this.variantsData?.options || [];
      const iColor = opts.indexOf('Color');
      if (iColor !== -1) return iColor;
      const iFabric = opts.indexOf('Fabric');
      if (iFabric !== -1) return iFabric;
      return opts.length ? opts.length - 1 : -1;
    }

    renderProductOptionValues(/** @type {number} */ optIdx) {
      // This requires lit-html templating
      // For now, we'll just clear if needed or skip
      if (!this.productOptionInventory) return;

      // If product option inventory needs updating, it would go here
      // This is complex HTML generation that requires the template system
    }

    /**
     * Handle manual upsell select dropdown change
     * Updates button, price, title, image when user manually selects a variant
     */
    onUpsellSelectChange(/** @type {Event} */ event) {
      if (this.isCustomRugs || !this.swatchUpsell) return;

      const selectEl = /** @type {HTMLSelectElement} */ (event.target);
      const selectedVariantId = parseInt(selectEl.value, 10);

      if (!selectedVariantId) return;

      const swatch_product = this.variantsData?.product_metafields?.swatch_product;
      if (!swatch_product || !swatch_product.variants) return;

      // Find variant by ID
      const swatchVariant = swatch_product.variants.find((/** @type {any} */ variant) => {
        return variant.id === selectedVariantId;
      });

      if (swatchVariant) {
        this.updateUpsellDisplay(swatchVariant);
      }
    }

    /**
     * Update upsell display elements (shared by both sync and manual selection)
     */
    updateUpsellDisplay(/** @type {any} */ swatchVariant) {
      if (!this.swatchUpsell || !swatchVariant) return;

      const titleEl = this.swatchUpsell.querySelector('.upsellTile__productTitle');
      const atcEl = /** @type {HTMLButtonElement | null} */ (this.swatchUpsell.querySelector('.upsellTile__ctaButton'));
      const imageEl = /** @type {HTMLImageElement | null} */ (this.swatchUpsell.querySelector('.upsellTile__img'));
      const priceEl = this.swatchUpsell.querySelector('.price-value__current');
      const compareEl = this.swatchUpsell.querySelector('.price-value__compare');
      const selectEl = /** @type {HTMLSelectElement | null} */ (this.swatchUpsell.querySelector('.upsellTile__optionsInput'));

      // Update image (hard coded 58x58 for Purchase a Sample swatch)
      if (imageEl && swatchVariant?.featured_image?.src) {
        const imgSrc = swatchVariant.featured_image.src;
        
        // Helper function to generate 58x58 image URL (hard coded for sample swatch)
        const imgURL = (/** @type {string} */ src, /** @type {string} */ size) => {
          if (!src) return null;
          // Remove ALL existing size parameters (including 2048x2048, 1920x1920, etc.)
          // More aggressive regex to catch all size variations
          let cleanSrc = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|3000x3000|master|\d+x\d+)+\./gi, '.');
          // Also handle URLs with size in different formats (e.g., /files/image_2048x2048.jpg)
          cleanSrc = cleanSrc.replace(/\/(\d+x\d+)\//g, '/');
          // Extract file extension
          const extMatch = cleanSrc.match(/\.(jpg|png|gif|jpeg|webp)(\?.*)?$/i);
          if (extMatch) {
            const ext = extMatch[0];
            // Replace extension with hard coded 58x58 size for sample swatch
            cleanSrc = cleanSrc.replace(ext, `_${size}${ext}`);
          }
          return cleanSrc;
        };
        
        // Hard coded 58x58 size for Purchase a Sample swatch (intrinsic size)
        const optimizedSize = '58x58';
        const optimizedUrl = imgURL(imgSrc, optimizedSize) || imgSrc;
        
        // Use only 58w in srcset (hard coded - no larger images)
        const optimizedSrcset = `${optimizedUrl} 58w`;
        
        // Get version parameter if exists
        const versionMatch = imgSrc.match(/\?v=([^&]+)/);
        const versionParam = versionMatch ? `?v=${versionMatch[1]}` : '';
        const finalUrl = optimizedUrl + versionParam;
        
        // Update image attributes with hard coded 58px size
        // Direct src update for immediate display (no lazyLoad delay for better performance)
        imageEl.src = finalUrl;
        imageEl.srcset = optimizedSrcset;
        imageEl.setAttribute('sizes', '58px'); // Hard coded 58px size
        imageEl.setAttribute('alt', swatchVariant.featured_image.alt || swatchVariant.title || '');
        
        // Remove lazyLoad classes to force immediate load (image is small, no need to lazy load)
        imageEl.classList.remove('lazyload', 'lazyloaded', 'lazyautosizes', 'ls-is-cached');
        
        // Preload the optimized image for instant display
        const preloadImg = new Image();
        preloadImg.onload = function() {
          // Ensure image is displayed once loaded
          if (imageEl.src !== finalUrl) {
            imageEl.src = finalUrl;
          }
        };
        preloadImg.src = finalUrl;
      }

      // Update title (matching TypeScript - no fallback)
      if (titleEl) {
        titleEl.textContent = swatchVariant.title || '';
        titleEl.setAttribute('title', swatchVariant.title || '');
      }

      // Update price
      if (priceEl && swatchVariant.price) {
        priceEl.textContent = this.formatMoney(swatchVariant.price);
      }

      // Update compare at price
      if (compareEl) {
        if (swatchVariant.compare_at_price && swatchVariant.compare_at_price > swatchVariant.price) {
          compareEl.textContent = this.formatMoney(swatchVariant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      // Update select dropdown (only if value changed to prevent infinite loop)
      if (selectEl && selectEl.value !== swatchVariant.id.toString()) {
        selectEl.value = swatchVariant.id.toString();
      }

      // Update add to cart button (matching TypeScript implementation)
      if (atcEl) {
        // Update variant ID attribute (this is what add-to-cart-handler.js reads)
        atcEl.setAttribute('add-to-cart', swatchVariant.id.toString());
        
        // Ensure button is initialized with add-to-cart handler if not already
        if (!atcEl.hasAttribute('data-add-to-cart-initialized')) {
          // Re-initialize handler if button was re-rendered
          if (typeof (/** @type {any} */ (window)).initializeAddToCartHandlers === 'function') {
            (/** @type {any} */ (window)).initializeAddToCartHandlers();
          }
        }

        if (swatchVariant.available) {
          atcEl.textContent = '+ Add';
          atcEl.removeAttribute('disabled');
          atcEl.classList.remove('bttn--disabled');
        } else {
          atcEl.setAttribute('disabled', '');
          atcEl.textContent = 'N/A';
          atcEl.classList.add('bttn--disabled');
        }
      }
    }

    updateSwatchUpsell() {
      if (this.isCustomRugs || !this.swatchUpsell) return;

      const swatch_product = this.variantsData?.product_metafields?.swatch_product;
      if (!swatch_product) {
        this.swatchUpsell.classList.add('upsellTile--hidden');
        return;
      }

      const swatchVariant = swatch_product.variants?.find((/** @type {any} */ variant) => {
        return variant.options.some((/** @type {any} */ opt) => this.currentOptions.includes(opt));
      });

      if (swatchVariant) {
        this.swatchUpsell.classList.remove('upsellTile--hidden');
        this.updateUpsellDisplay(swatchVariant);
      } else {
        this.swatchUpsell.classList.add('upsellTile--hidden');
      }
    }

    updateLowInventoryNotice() {
      if (!(this.lowInventoryNotice && this.lowInventoryThreshold)) return;

      if (this.currentVariant.metafields.quantity == 0) {
        this.lowInventoryNotice.textContent = 'Out of Stock';
      } else if (this.currentVariant.metafields.quantity <= this.lowInventoryThreshold) {
        this.lowInventoryNotice.textContent = `Only ${this.currentVariant.metafields.quantity} left`;
      } else {
        this.lowInventoryNotice.textContent = '';
      }
    }

    updateSwatches() {
      const imageSwatchOptions = Array.from(this.querySelectorAll('[product-option-value]'));
      if (!imageSwatchOptions.length) return;

      const colorIdx = this.variantsData?.options?.indexOf('Color');
      if (colorIdx === -1) return;

      const options = [...this.currentOptions];
      const selectedColor = options[colorIdx];

      imageSwatchOptions.forEach((opt) => {
        const optValue = opt.getAttribute('product-option-value');
        const swatch = /** @type {HTMLElement | null} */ (opt.querySelector('.swatch'));
        if (!swatch) return;

        this.variants.forEach((v) => {
          if (v.options.includes(optValue) && v.options.includes(selectedColor) && v.featured_image) {
            swatch.style.backgroundImage = `url(${v.featured_image.src})`;
          }
        });
      });
    }

    updateShopTheCollection() {
      // Update shop the collection sections
      if (!this.shopCollectionSections || this.shopCollectionSections.length === 0) return;

      // This would require the ShopCollection directive
      // For now, we'll skip the implementation
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const dropdownButtons = document.querySelectorAll('.selectOption__select');
  dropdownButtons.forEach(button => {
    // Only add fallback handler if SelectProductOptionHandler is not managing this
    const parentFieldset = button.closest('.selectOption');
    
    // Skip if SelectProductOptionHandler is already managing this dropdown
    if (parentFieldset && (parentFieldset.selectProductOptionHandler || parentFieldset.hasAttribute('data-select-option-initialized'))) {
      return; // SelectProductOptionHandler is handling this, skip our fallback
    }
    
    // Fallback handler for dropdowns not managed by SelectProductOptionHandler
    button.addEventListener('click', function (event) {
      const fieldset = this.closest('.selectOption');
      const optionsContainer = fieldset.querySelector('.selectOption__options');
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeDropdown(this, fieldset, optionsContainer);
      } else {
        openDropdown(this, fieldset, optionsContainer);
      }
    });
  });

  function openDropdown(btn, fieldset, container) {
    fieldset.classList.add('selectOption--open');
    btn.setAttribute('aria-expanded', 'true');
    btn.style.borderRadius = "4px 4px 0px 0px";
    btn.style.borderBottom = "none";

    container.setAttribute('aria-hidden', 'false');
    container.style.pointerEvents = 'all';
    container.style.height = 'auto';
    container.style.opacity = '1';
    const textSpan = btn.querySelector('.selectOption__select--text');
    const labelName = fieldset.querySelector('legend').innerText;
    textSpan.innerText = `Choose ${labelName}`;
  }

  function closeDropdown(btn, fieldset, container) {
    fieldset.classList.remove('selectOption--open');
    btn.setAttribute('aria-expanded', 'false');
    btn.style.borderRadius = "";
    btn.style.borderBottom = "";

    container.setAttribute('aria-hidden', 'true');
    container.style.pointerEvents = 'none';
    container.style.height = '0px';
    container.style.opacity = '0';
    const textSpan = btn.querySelector('.selectOption__select--text');
    const selectedInput = fieldset.querySelector('input[type="radio"]:checked');

    if (selectedInput) {
      const valueSpan = selectedInput.parentElement.querySelector('.selectOption__value');
      if (valueSpan) {
        textSpan.innerText = valueSpan.innerText.trim();
      }
    }
  }
  const radioInputs = document.querySelectorAll('.selectOption__options input[type="radio"]');
  radioInputs.forEach(input => {
    input.addEventListener('change', function () {
      const fieldset = this.closest('.selectOption');
      const btn = fieldset.querySelector('.selectOption__select');
      const container = fieldset.querySelector('.selectOption__options');
      closeDropdown(btn, fieldset, container);
    });
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.selectOption')) {
      dropdownButtons.forEach(btn => {
        const fieldset = btn.closest('.selectOption');
        const container = fieldset.querySelector('.selectOption__options');
        if (btn.getAttribute('aria-expanded') === 'true') {
          closeDropdown(btn, fieldset, container);
        }
      });
    }
  });
});